import styled from "styled-components";

const Wrapper = styled.div`
    flex-flow: row;
    flex: 1;
    align-self: stretch;
    width: 100%;
    position: relative;
    overflow: auto;
    align-items: flex-start;
    display: flex;
    min-height: calc(100vh - 360px);
`;

export default Wrapper;